import { Button, ButtonProps, Flex, FlexProps } from "@chakra-ui/react";

/**
 * Wrapper padrão das ações de rodapé de modal.
 * Aplica espaçamento fixo (gap 12px) e alinha à direita, na ordem [Cancelar] [Primário].
 * Padroniza o rodapé que hoje cada modal monta à mão (GEN-2844).
 */
export const ModalFooterActions = ({ children, ...rest }: FlexProps) => (
  <Flex width="100%" justifyContent="flex-end" alignItems="center" gap={3} {...rest}>
    {children}
  </Flex>
);

/**
 * Botão secundário padrão de rodapé de modal ("Fechar"/"Cancelar").
 * Baixa ênfase e cor neutra para não competir com o CTA primário; herda o
 * fontWeight 400 do tema. Hover = apenas fundo neutro (state layer), mantendo
 * os cantos arredondados do sistema.
 */
export const ModalCancelButton = ({ children = "Fechar", ...rest }: ButtonProps) => (
  <Button
    variant="ghost"
    bgColor="transparent"
    color="#171923"
    fontFamily="Poppins"
    fontSize="14px"
    fontWeight={400}
    _hover={{ bgColor: "#F2F0F4" }}
    {...rest}
  >
    {children}
  </Button>
);
